import { render, staticRenderFns } from "./Logs.vue?vue&type=template&id=cb9131b4&scoped=true"
import script from "./Logs.vue?vue&type=script&lang=ts"
export * from "./Logs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb9131b4",
  null
  
)

export default component.exports